'use client';

import { useEffect, useState } from 'react';

export const useScrollDirection = () => {
  const [showContent, setShowContent] = useState(true);

  useEffect(() => {
    const threshold = 0.6;
    const contentHeight = document.scrollingElement?.scrollHeight || 5000;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (scrollY < threshold * contentHeight) {
        ticking = false;
        return;
      }
      setShowContent(scrollY < lastScrollY);
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [showContent]);

  return {
    showContent,
  };
};
